import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ValidationErrors } from '@angular/forms';

// LIBRARIES/LIBRERIAS  ---------------------------------------------------
import * as XLSX from 'xlsx';
import { values, zipObject, concat, indexOf, map } from 'lodash';
import { HttpClient } from '@angular/common/http';

// SERVICES/SERVICIOS  ----------------------------------------------------
import { ValidatorService } from '@asambleas-services/validators/validator.service';
import { environment } from '@asambleas-env/environment';
import { UserFeedbackService } from '@asambleas-modules/user-feedback/user-feedback.service';



@Component({
    selector: 'app-masive-members-load',
    templateUrl: './masive-members-load.component.html',
    styleUrls: ['./masive-members-load.component.scss']
})
export class MasiveMembersLoadComponent implements OnInit {

    file_header: any = []
    lines: any = []
    docDownloadLink: string = ''

    // control
    isAllowToSend: boolean = false
    checkState = {} as XLSError
    generalErrors: Array<XLSError> = []

    userForm: FormGroup
    // this array contains the form field names
    parallelHeader: Array<any> = ['name', 'surname', 'second_name', 'second_surname', 'email', 'gender', 'document_type', 'document_number', 'birthdate', 'birthplace', 'civil_status', 'residence_address', 'residence_city'];

    constructor(
        private fb: FormBuilder,
        private customValidators: ValidatorService,
        private http: HttpClient,
        public feedback: UserFeedbackService
    ) { }

    ngOnInit() {
        this.reset()
        this.docDownloadLink = environment.docMasiveUserLoad
    }

    changeListener($event): void {
        this.readThis($event.target);
    }

    reset() {
        this.isAllowToSend = false
        this.generalErrors = []
        this.checkState.hasError = false
        this.checkState.message = ''
        this.checkState.rowLine = -1
    }

    /**
     * Carga en memoria del cliente el documento xls para poder ser procesado
     * @param inputValue xls.document
     */
    readThis(inputValue: any): void {
        this.reset()

        var file: File = inputValue.files[0];
        var myReader: FileReader = new FileReader();
        var rABS = true; // true: readAsBinaryString ; false: readAsArrayBuffer

        let str = file.name.split('.').pop()

        myReader.onloadend = (e) => {
            // you can perform an action with readed data here
            // console.log(myReader.result);

            if (str !== 'xlsx' && str !== 'XLSX') {
                // this.toast.pop('error', null, 'El archivo elegido no corresponde con un documento de Excel')
            } else {
                var data = myReader.result;
                if (!rABS) {
                    let d = new Uint8Array(data)
                    var workbook = XLSX.read(d, { type: rABS ? 'binary' : 'array' });
                } else {
                    var workbook = XLSX.read(data, { type: rABS ? 'binary' : 'array' });
                }

                var sheet_name_list = workbook.SheetNames;
                // console.log('Hay ', sheet_name_list.length, ' hojas en su archivo')

                if (sheet_name_list.length > 0) {
                    // Obtener solo la primera hoja, las otras contienen las listas de valores
                    let y = sheet_name_list[0]
                    // console.log(y)
                    var worksheet = workbook.Sheets[y];
                    var headers = {};
                    var data: any = [];
                    var z
                    for (z in worksheet) {
                        if (z[0] === '!') continue;
                        //parse out the column, row, and value
                        var col = z.substring(0, 1);
                        var row = parseInt(z.substring(1));
                        var value = worksheet[z].v;

                        //store header names
                        if (row == 1) {
                            headers[col] = value;
                            continue;
                        }

                        if (!data[row]) {
                            data[row] = {} as any;
                        }
                        data[row][headers[col]] = value;
                    }

                    //drop those first two rows which are empty
                    data.shift();
                    data.shift();

                    let temp_data: Array<any> = []

                    // agregando las cabeceras en la variable de cabeceras
                    values(headers).forEach(v => {
                        // this.header.push(v);
                        this.file_header.push(v)
                    })
                    // agregando los datos de los usuarios en la variable de datos
                    data.forEach(r => { temp_data.push(values(r)) });
                    this.lines = temp_data

                    // console.log(this.lines)
                    // console.log(this.file_header)

                    this.checkState = this.allDataIsComplete()
                    if (!this.checkState.hasError) {
                        this.rowValidation()
                    } else {
                        // console.log('parece que hay filas con datos faltantes', this.checkState)
                    }
                } else {
                    // console.log('no hay hojas el')
                    window.alert('no hay hojas en el documento proporcinado')
                }

            }
        }
        if (rABS) myReader.readAsBinaryString(file); else myReader.readAsArrayBuffer(file);
    }

    /**
     * Check if every row has the same length. Returns an object with the error location
     */
    allDataIsComplete(): XLSError {
        let is: boolean = true
        let rowNumber: number = 2
        let e = {} as XLSError

        e.hasError = false

        this.lines.forEach(row => {
            is = (this.parallelHeader.length == row.length)
            if (!is) {
                e.hasError = true
                e.rowLine = rowNumber
                e.message = 'Falta uno o más datos'

                return e
            }
            rowNumber++
        });
        return e
    }

    /**
     * Crea un objecto de cada usuario usando partiendo el arreglo de la cabecera con las llaves del form
     */
    rowsAsObjects(): Array<any> {
        let rows: Array<any> = []
        this.lines.forEach(row => {
            rows.push(zipObject(this.parallelHeader, row))
        });
        return rows
    }

    /**
     * Using forms, validates xls input data
     */
    rowValidation() {
        this.lines = this.rowsAsObjects()
        // console.log(this.lines)
        var rowNumber: number = 2;
        var errors: Array<XLSError> = []

        // console.log('Running rows validation for user data');

        this.userForm = this.fb.group({
            name: ['', [Validators.required]],
            surname: ['', [Validators.required]],
            second_name: ['', [Validators.required]],
            second_surname: ['', [Validators.required]],
            gender: ['', [Validators.required, Validators.maxLength(1)]],
            document_type: ['', [Validators.required]],
            document_number: ['', [Validators.required]],
            birthdate: ['', [Validators.required, this.customValidators.validDateYYYYMMDD]],
            birthplace: ['', [Validators.required]],
            civil_status: ['', [Validators.required]],
            residence_address: ['', [Validators.required]],
            residence_city: ['', [Validators.required]],
            email: ['', [Validators.required, Validators.email]]
        })

        this.lines.forEach(row => {
            this.userForm.patchValue(row)
            this.userForm.updateValueAndValidity()
            if (!this.userForm.valid) {
                var a: any = []
                a = this.getFormValidationErrors(rowNumber)
                errors = concat(a, errors)
            }
            rowNumber++;
        });

        if (errors.length > 0) {
            this.generalErrors = errors
        } else {
            this.isAllowToSend = true

        }
    }

    /**
     * Obtiene todos los errores de una sola fila del formulario
     * @param rownum número de la fila actual
     */
    getFormValidationErrors(rownum): Array<XLSError> {
        var errors: Array<XLSError> = []
        Object.keys(this.userForm.controls).forEach(key => {
            const controlErrors: ValidationErrors = this.userForm.get(key).errors;
            if (controlErrors != null) {
                Object.keys(controlErrors).forEach(keyError => {
                    key = this.file_header[indexOf(this.parallelHeader, key)]
                    if (key != undefined) {
                        let e = {} as XLSError
                        e.hasError = true
                        e.rowLine = rownum
                        e.message = 'La columna ' + key + ', es invalida en la posición ' + rownum
                        errors.push(e)
                    }
                });
            }
        });
        return errors
    }

    sendMasiveRegistration() {
        console.log('Se insertaran', this.lines)
        let data = JSON.stringify(this.lines)
        this.http.post(
            environment.apiEndPoint + '/usuarios/registro-masivo',
            { usuarios: JSON.parse(data) }
        ).subscribe(res => {
            console.log(res)
            this.feedback.openSnackbar({ message: res['message'] })
        }, err => {
            this.feedback.openDialog({
                title: 'Los siguientes elementos presentaron errores',
                body: this.convertingTheError(err.error).join('<br>')
            })
        })
    }

    convertingTheError(error: Array<any>): Array<string> {
        let s: Array<string> = []

        for (let i = 0; i < error.length; i++) {
            let n = i + 1
            const e = error[i];
            let keys = Object.keys(e)
            for (let index = 0; index < keys.length; index++) {
                const str = keys[index];
                s.push('Fila ' + n + ', el campo <b>"' + str + '"</b>: ' + e[str]);
            }
        }
        return s;
    }
}

/**
 * Para control de errores del este componente
 */
interface XLSError {
    hasError: boolean;
    rowLine: number;
    message: string;
}



// WEBPACK FOOTER //
// ./src/app/admin/pages/masive-members-load/masive-members-load.component.ts